export const TABLE_DATA_INPUT_HEIGHT_CLASS = 'h-[34px]' as const;
export const TABLE_DATA_ROW_CELL_CLASSES =
  'box-border h-[54px] min-h-[54px] max-h-[54px] overflow-hidden py-0.5 px-4 text-ellipsis whitespace-nowrap' as const;
